/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiModelsEnumerationTypesEmailDesignTemplate,
  WebApiServicesDataTransferObjectsInviteServiceCreateInviteResultDto,
  WebApiServicesDataTransferObjectsInviteServiceCreateReminderDto,
  WebApiServicesDataTransferObjectsInviteServiceCreateReminderResultDto,
  WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto,
  WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto,
  WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto,
  WebApiServicesDataTransferObjectsUserServiceCreateEventResultDto,
} from '../models';
import {
    WebApiModelsEnumerationTypesEmailDesignTemplateFromJSON,
    WebApiModelsEnumerationTypesEmailDesignTemplateToJSON,
    WebApiServicesDataTransferObjectsInviteServiceCreateInviteResultDtoFromJSON,
    WebApiServicesDataTransferObjectsInviteServiceCreateInviteResultDtoToJSON,
    WebApiServicesDataTransferObjectsInviteServiceCreateReminderDtoFromJSON,
    WebApiServicesDataTransferObjectsInviteServiceCreateReminderDtoToJSON,
    WebApiServicesDataTransferObjectsInviteServiceCreateReminderResultDtoFromJSON,
    WebApiServicesDataTransferObjectsInviteServiceCreateReminderResultDtoToJSON,
    WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDtoFromJSON,
    WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDtoToJSON,
    WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDtoFromJSON,
    WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDtoToJSON,
    WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDtoFromJSON,
    WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDtoToJSON,
    WebApiServicesDataTransferObjectsUserServiceCreateEventResultDtoFromJSON,
    WebApiServicesDataTransferObjectsUserServiceCreateEventResultDtoToJSON,
} from '../models';

export interface ApiInviteCreatePostRequest {
    emails?: Array<string>;
    eventId?: number;
    message?: string;
    subject?: string;
    files?: Array<Blob>;
    designHeader?: string;
    designImageUrl?: string;
    designAccentColor?: string;
    designTextColor?: string;
    designEmailDesignTemplate?: WebApiModelsEnumerationTypesEmailDesignTemplate;
}

export interface ApiInviteEventIdGetRequest {
    eventId: string;
}

export interface ApiInviteInviteIdDeleteRequest {
    inviteId: number;
}

export interface ApiInvitePreviewMailPostRequest {
    webApiServicesDataTransferObjectsInviteServicePreviewEventMailDto?: WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDto;
}

export interface ApiInviteSendReminderForInvitesPostRequest {
    webApiServicesDataTransferObjectsInviteServiceCreateReminderDto?: WebApiServicesDataTransferObjectsInviteServiceCreateReminderDto;
}

export interface ApiInviteSendTestMailPostRequest {
    webApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto?: WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto;
}

/**
 * 
 */
export class InviteApi extends runtime.BaseAPI {

    /**
     * Craetes new event with connected times
     */
    async apiInviteCreatePostRaw(requestParameters: ApiInviteCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsInviteServiceCreateInviteResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.emails) {
            requestParameters.emails.forEach((element) => {
                formParams.append('Emails', element as any);
            })
        }

        if (requestParameters.eventId !== undefined) {
            formParams.append('EventId', requestParameters.eventId as any);
        }

        if (requestParameters.message !== undefined) {
            formParams.append('Message', requestParameters.message as any);
        }

        if (requestParameters.subject !== undefined) {
            formParams.append('Subject', requestParameters.subject as any);
        }

        if (requestParameters.files) {
            requestParameters.files.forEach((element) => {
                formParams.append('files', element as any);
            })
        }

        if (requestParameters.designHeader !== undefined) {
            formParams.append('Design.Header', requestParameters.designHeader as any);
        }

        if (requestParameters.designImageUrl !== undefined) {
            formParams.append('Design.ImageUrl', requestParameters.designImageUrl as any);
        }

        if (requestParameters.designAccentColor !== undefined) {
            formParams.append('Design.AccentColor', requestParameters.designAccentColor as any);
        }

        if (requestParameters.designTextColor !== undefined) {
            formParams.append('Design.TextColor', requestParameters.designTextColor as any);
        }

        if (requestParameters.designEmailDesignTemplate !== undefined) {
            formParams.append('Design.EmailDesignTemplate', new Blob([JSON.stringify(WebApiModelsEnumerationTypesEmailDesignTemplateToJSON(requestParameters.designEmailDesignTemplate))], { type: "application/json", }));
                    }

        const response = await this.request({
            path: `/api/Invite/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsInviteServiceCreateInviteResultDtoFromJSON(jsonValue));
    }

    /**
     * Craetes new event with connected times
     */
    async apiInviteCreatePost(requestParameters: ApiInviteCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsInviteServiceCreateInviteResultDto> {
        const response = await this.apiInviteCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets invites by eventId
     */
    async apiInviteEventIdGetRaw(requestParameters: ApiInviteEventIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling apiInviteEventIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Invite/{EventId}`.replace(`{${"EventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDtoFromJSON(jsonValue));
    }

    /**
     * Gets invites by eventId
     */
    async apiInviteEventIdGet(requestParameters: ApiInviteEventIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto> {
        const response = await this.apiInviteEventIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiInviteInviteIdDeleteRaw(requestParameters: ApiInviteInviteIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsUserServiceCreateEventResultDto>> {
        if (requestParameters.inviteId === null || requestParameters.inviteId === undefined) {
            throw new runtime.RequiredError('inviteId','Required parameter requestParameters.inviteId was null or undefined when calling apiInviteInviteIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Invite/{InviteId}`.replace(`{${"InviteId"}}`, encodeURIComponent(String(requestParameters.inviteId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsUserServiceCreateEventResultDtoFromJSON(jsonValue));
    }

    /**
     * 
     */
    async apiInviteInviteIdDelete(requestParameters: ApiInviteInviteIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsUserServiceCreateEventResultDto> {
        const response = await this.apiInviteInviteIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Shows an invite or a reminder the way it will look for the recipient
     */
    async apiInvitePreviewMailPostRaw(requestParameters: ApiInvitePreviewMailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Invite/previewMail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsInviteServicePreviewEventMailDtoToJSON(requestParameters.webApiServicesDataTransferObjectsInviteServicePreviewEventMailDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Shows an invite or a reminder the way it will look for the recipient
     */
    async apiInvitePreviewMailPost(requestParameters: ApiInvitePreviewMailPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiInvitePreviewMailPostRaw(requestParameters, initOverrides);
    }

    /**
     * Send reminder for invites without reply
     */
    async apiInviteSendReminderForInvitesPostRaw(requestParameters: ApiInviteSendReminderForInvitesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsInviteServiceCreateReminderResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Invite/sendReminderForInvites`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsInviteServiceCreateReminderDtoToJSON(requestParameters.webApiServicesDataTransferObjectsInviteServiceCreateReminderDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsInviteServiceCreateReminderResultDtoFromJSON(jsonValue));
    }

    /**
     * Send reminder for invites without reply
     */
    async apiInviteSendReminderForInvitesPost(requestParameters: ApiInviteSendReminderForInvitesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsInviteServiceCreateReminderResultDto> {
        const response = await this.apiInviteSendReminderForInvitesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends an invite or a reminder to one address as a test, without creating an invite
     */
    async apiInviteSendTestMailPostRaw(requestParameters: ApiInviteSendTestMailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Invite/sendTestMail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsInviteServiceSendTestEventMailDtoToJSON(requestParameters.webApiServicesDataTransferObjectsInviteServiceSendTestEventMailDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Sends an invite or a reminder to one address as a test, without creating an invite
     */
    async apiInviteSendTestMailPost(requestParameters: ApiInviteSendTestMailPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiInviteSendTestMailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
